import type { CalendarDesign } from "#internal"

import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { PocketBand } from "../PocketBand"
import { PocketMonths } from "../PocketMonths"

/** Clan, a pocket calendar on one side: a band of picture with the year on it
 * at its head, its months three across under it, the contact at its foot. */
export const Clan: CalendarDesign = {
  cover: PictureCover({}),
  page: boxes => {
    const { areas, below } = PocketBand({ ...boxes, outer: boxes.body }, 0.13)
    return [...areas, ...PocketMonths(below, boxes.year, 3), Area.footer(boxes.contact)]
  },
  pages: "year",
}
